export { default, getStaticProps } from './[...slug]'
